import React from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { CreateEmptyReportIcon } from '@/components/reports/icons/createEmptyReportIcon';
import { CreateTemplateReportIcon } from '@/components/reports/icons/createTemplateReportIcon';

const cardStyles: SxProps = {
  '&:hover': {
    backgroundColor: 'primary.hovered',
    borderColor: 'primary.main',
  },
  backgroundColor: 'secondary.dark',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  cursor: 'pointer',
  p: 2,
  textAlign: 'left',
};

export const CreationTypeSelection = ({
  handleCreateFromScratch,
  handleShowTemplates,
  sx,
  variant = 'column',
}: {
  handleCreateFromScratch: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleShowTemplates: (e: React.MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps;
  variant?: 'column' | 'row';
}) => {
  return (
    <Stack direction={variant} justifyContent="center" spacing={2} sx={sx}>
      <Card component="button" onClick={handleShowTemplates} sx={cardStyles}>
        <CreateTemplateReportIcon />
        <Typography mt={2}>Use a template</Typography>
        <Typography color="text.secondary" variant="caption">
          Use report templates that you can customize.
        </Typography>
      </Card>
      <Card component="button" onClick={handleCreateFromScratch} sx={cardStyles}>
        <CreateEmptyReportIcon />
        <Typography mt={2}>Build from scratch</Typography>
        <Typography color="text.secondary" variant="caption">
          Start with an empty, customizable canvas.
        </Typography>
      </Card>
    </Stack>
  );
};
